"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function isScreenSizeLarge() {
  if ($(window).width() > 999) {
    return true;
  }
}

var deferred = {};
Shopify.theme.asyncView = {
  /**
   * Load the template given by the provided URL into the provided
   * view
   *
   * @param {string} url - The url to load.
   * @param {string} view - The view to load into.
   * @param {object} options - Config options.
   * @param {string} options.hash - A hash of the current page content.
   */
  load: function load(url, view) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var data;

    if (url in deferred) {
      return deferred[url];
    }

    var $deferred = $.Deferred();
    deferred[url] = $deferred;

    if (options.hash) {
      data = sessionStorage.getItem(url);

      if (data) {
        var deserialized = JSON.parse(data);

        if (options.hash === deserialized.options.hash) {
          delete deferred[url];
          return $deferred.resolve(deserialized).promise();
        }
      }
    } // NOTE The $.ajax request has the cache option set to false.
    // This is to prevent certain browsers from returning cached
    // versions of the url we are requesting.
    // See this PR for more info: https://github.com/pixelunion/shopify-asyncview/pull/4


    $.ajax({
      url: url,
      cache: false,
      data: "view=".concat(view),
      dataType: 'html',
      headers: {
        'cache-control': 'no-cache'
      },
      success: function success(response) {
        var el = document.createElement('div');
        el.innerHTML = response;
        var responseOptions = JSON.parse(el.querySelector('[data-options]').innerHTML);
        var htmls = el.querySelectorAll('[data-html]');
        var html = {};

        if (htmls.length === 1 && htmls[0].getAttribute('data-html') === '') {
          html = htmls[0].innerHTML;
        } else {
          for (var _i = 0; _i < htmls.length; _i++) {
            html[htmls[_i].getAttribute('data-html')] = htmls[_i].innerHTML;
          }
        }

        if (options.hash) {
          try {
            sessionStorage.setItem(url, JSON.stringify({
              options: responseOptions,
              html: html
            }));
          } catch (error) {
            console.error(error);
          }
        }

        delete deferred[url];
        return $deferred.resolve({
          options: responseOptions,
          html: html
        });
      },
      error: function error() {
        delete deferred[url];
        return $deferred.reject();
      }
    });
    return $deferred.promise();
  }
};

// local helper defination start
Shopify.theme.localHelper = {
  get: function (key) {
      return JSON.parse(localStorage.getItem(key));
  },
  save: function (key, value) {
      localStorage.setItem(key, value);
  },
  update: function (key, value) {
      // TODO:
  },
  delete: function (key) {
      localStorage.removeItem(key);
  }
}

Shopify.theme.getSectionData = function ($section) {
  var sectionId = $section.attr('id').replace('shopify-section-', '');
  var $dataEl = $section.find('[data-section-data][data-section-id=' + sectionId + ']').first();
  if (!$dataEl) return {}; // Load data from attribute, or innerHTML

  var data = $dataEl.data('section-data') || $dataEl.html();

  try {
    return JSON.parse(data);
  } catch (error) {
    console.warn("Sections: invalid section data found. ".concat(error.message));
    return {};
  }
};

Shopify.theme.quantityBox = {
  init: function init() {
    $('body').on('click', '[data-update-quantity]:not([disabled])', function () {
      Shopify.theme.quantityBox.updateQuantity($(this));
    });
    $('body').on('keyup keydown change', '.quantity-input', function () {
      Shopify.theme.quantityBox.updateQuantity($(this));
    });
  },
  updateQuantity: function updateQuantity($el) {
    var $quantityBox = $el.parents('.product-quantity-box');
    var $input = $('.quantity-input', $quantityBox);
    var lineID = $quantityBox.parents('[data-line-item]').data('line-item');
    var val = parseInt($input.val());
    var valMax = 100000000000000000;
    var valMin = $input.attr('min') || 0;


    if ($input.attr('max') != null) {
      valMax = $input.attr('max');
    }

    if (isNaN(val) || val < valMin) {
      $input.val(valMin);
      return false;
    } else if (val > valMax) {
      $input.val(valMax);
      return false;
    }

    if ($el.data('update-quantity') === 'plus') {
      // Increase quantity input by one
      if (val < valMax) {
        val++;
        $input.val(val);
      }
    } else if ($el.data('update-quantity') === 'minus') {
      // Decrease quantity by one
      if (val > valMin) {
        val--;
        $input.val(val);
      }
    }

    if (val === 1 || val === 0) {
      $('.quantity-minus', $quantityBox).attr('disabled', true);
      $('.quantity-plus', $quantityBox).attr('disabled', false);
    } else if (val >= valMax) {
      $('.quantity-plus', $quantityBox).attr('disabled', true);
      $('.quantity-minus', $quantityBox).attr('disabled', false);
      $input.val(valMax);
    } else {
      $('.quantity-minus', $quantityBox).attr('disabled', false);
      $('.quantity-plus', $quantityBox).attr('disabled', false);
    } // Update quantity if within cart (vs on the product page)


    if ($el.parents('[data-line-item]').length) {
      var _lineID = $quantityBox.data('line-item-key');
      Shopify.theme.quantityBox.updateCart(_lineID, val);
    }
  },
  updateCart: function updateCart(lineID, quantity) {
    $('.quantity-warning').removeClass('animated bounceIn');
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: "quantity=".concat(quantity, "&line=").concat(lineID),
      dataType: 'json',
      success: function success(cart) {
        var newQuantity = 0;
        var itemsLeftText = '';
        var quantityWarning = $("[data-line-item=\"".concat(lineID, "\"]")).find('.quantity-warning');
        var $quantityBox = $("[data-line-item=\"".concat(lineID, "\"]")).find('.product-quantity-box'); //check to see if there are correct amount of products in array

        var cartItemsLineID = lineID - 1;

        if (typeof cart.items[cartItemsLineID] !== "undefined") {
          newQuantity = cart.items[cartItemsLineID].quantity;
        }

        if (quantity > 0 && quantity != newQuantity) {
          if (newQuantity == 1) {
            itemsLeftText = Shopify.translation.product_count_one;
            quantityWarning.text("".concat(newQuantity, " ").concat(itemsLeftText));
            $('.quantity-minus', $quantityBox).attr('disabled', true);
          } else {
            itemsLeftText = Shopify.translation.product_count_other;
            quantityWarning.text("".concat(newQuantity, " ").concat(itemsLeftText));
          }
        } // Apply quantity warning


        quantityWarning.addClass('animated bounceIn');

        checkForFreebie();
        
        setTimeout(() => {
          if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
            Shopify.theme.jsAjaxCart.updateView();
          }
  
          if (Shopify.theme.jsCart) {
            Shopify.theme.jsCart.updateView(cart, lineID);
          }
  
        }, 1000);

      },
      error: function error(XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  unload: function unload($target) {
    $('.quantity-input').off();
    $('[data-update-quantity]').off();
  }
};

function totalPriceForProductTag(cart, tag) {
  let lineItems = $('.template-cart').length ? $('.order-table .ajax-cart__product') : $('.ajax-cart--drawer .ajax-cart__product');
  let totalTagPrice = 0;
  lineItems.each(function(){
    const tags = $(this).data('line-item-tags');
    const lineItemId = $(this).data('line-item-id');
    if (tags.length) {
      const hasSpecificTag = tags.filter(itemTag => itemTag.toLowerCase() === tag.toLowerCase());
      if (hasSpecificTag.length) {
        const cartItem = cart.items.find(item => item.id === lineItemId);
        if (cartItem) {
          totalTagPrice += cartItem.original_line_price;
        }
      }
    }
  });
  return totalTagPrice;
}

/* Check for freebie or add freebie to cart */
function checkForFreebie() {

  $.getJSON('/cart.js', function(cart) {
    var variant_id = window.freebieVariantID,
      free_gift_over_price = window.free_gift_over_price,
      enable_free_gift = window.enable_free_gift,
      no_min_spend =  window.no_min_spend,
      cartItems = cart.items,
      qtyInTheCart = 0,
      cartUpdates = {},
      cartTotal = cart.total_price,
      enable_free_gift_over_100_spend = window.enable_free_gift_over_100_spend,
      free_gift_over_100_spend_variant_id = window.free_gift_over_100_spend_variant_id,
      free_gift_over_100_product_tag = window.free_gift_over_100_product_tag,
      enable_second_no_min_spend_free_gift = window.enable_second_no_min_spend_free_gift,
      second_free_gift_without_threshold_variant_id = window.second_free_gift_without_threshold_variant_id,
      enable_buy_1_get_1 = window.enable_buy_1_get_1,
      buy_1_get_1_variant = window.buy_1_get_1_variant,
      freebie_buy_1_get_1_variant = window.freebie_buy_1_get_1_variant;
    if(enable_free_gift == true){

      const isOnlyGC = cartItems.every(item => item.product_type === "Gift Card" || item.product_type === "Gift Cards");
      if (isOnlyGC) {
        Shopify.theme.jsAjaxCart.updateView();
        return
      };
      
      // remove freebie when the cart total is below the threshold
      const hasFreebie = cart.items.find(item => item.id === variant_id && item.line_price === 0);
      if (hasFreebie && (cart.total_price - hasFreebie.original_price) < free_gift_over_price & cart.items.length > 1) {
        cartUpdates = {  [variant_id] : 0 }
        $.post('/cart/update.js', {
          updates: cartUpdates,
          success: function success() {
            window.setTimeout(function () {
              Shopify.theme.jsAjaxCart.updateView();
            }, 500);
          }
        });
      }

      for (var i=0; i<cartItems.length; i++) {
        if ( cartItems[i].id === variant_id) {
          qtyInTheCart = cartItems[i].quantity;
          break;
        }
      }

      var variantObject = cartItems.find((o) => { return o["variant_id"] === variant_id });
    
      if(typeof variantObject !== "undefined"){
        if(variantObject.final_price > 0 && variantObject.quantity >= 1){
          return;
        }
      }
    
      if ( ( cartItems.length === 1 ) && ( qtyInTheCart > 0 ) ) {
        cartUpdates = {  [variant_id] : 0 }
      }
        
      else if ( ( cartItems.length >= 1 ) && ( qtyInTheCart !== 1 ) && (cartTotal >=  free_gift_over_price  ) ) {
        cartUpdates = { [variant_id]: 1 }
      }
      else {
        return;
      }

      $.post('/cart/update.js', {
        updates: cartUpdates,
        success: function success() {
          window.setTimeout(function () {
            Shopify.theme.jsAjaxCart.updateView();
          }, 500);
        }
      });
    } 
    

    else if ( no_min_spend == true ) {
      // remove freebie when the cart total is below the threshold
      const hasFreebie = cart.items.find(item => item.id === variant_id && item.line_price === 0 || item.id === second_free_gift_without_threshold_variant_id && item.line_price === 0 );
      const isOnlyGC = cartItems.every(item => item.product_type === "Gift Card" || item.product_type === "Gift Cards");
      const hasGC = cartItems.some(item => item.product_type === "Gift Card" || item.product_type === "Gift Cards");
      const hasOver100Freebie = cartItems.find(item => {
        return item.id === free_gift_over_100_spend_variant_id && item.final_price === 0;
      });
      let removeFreebie;
      const freebieInCart = cartItems.find(item => item.id === variant_id || item.id === second_free_gift_without_threshold_variant_id );
      const normalItem = cartItems.filter(item => {
        return ( item.product_type !== "Gift Card" && item.product_type !== "Gift Cards") && 
        (item.id !== variant_id) && 
        (item.id !== second_free_gift_without_threshold_variant_id) || 
        (item.id === free_gift_over_100_spend_variant_id && item.final_price !== 0);
      });
      removeFreebie = freebieInCart && normalItem.length === 0 ? true : false;
      if (normalItem.length === 1 && normalItem[0].id === free_gift_over_100_spend_variant_id && normalItem[0].final_price === 0) {
        removeFreebie = true;
      }
      if (isOnlyGC) {
        Shopify.theme.jsAjaxCart.updateView();
        return
      };

      // 2nd freebie
      if (cart.total_price === 0) {
        let allFreebie = cart.items.every(item => item.id === variant_id || (item.id === second_free_gift_without_threshold_variant_id && item.final_price === 0)) 
        if (allFreebie) {
          removeFreebie = true;
        }
      }

      if (hasFreebie && (cart.total_price - hasFreebie.original_price) < free_gift_over_price & cart.items.length > 1) {
        cartUpdates = {  [variant_id] : 0 }
        $.post('/cart/update.js', {
          updates: cartUpdates,
          success: function success() {
            window.setTimeout(function () {
              Shopify.theme.jsAjaxCart.updateView();
            }, 500);
          }
        });
      }

      for (var i=0; i<cartItems.length; i++) {
        if ( cartItems[i].id ===  variant_id  ) {
          qtyInTheCart = cartItems[i].quantity;
          break;
        }
      }

      if ( ( cartItems.length === 1 ) && ( qtyInTheCart > 0 ) || removeFreebie ) {
        cartUpdates = {  [variant_id] : 0 }

          // 2nd freebie
          if ( enable_second_no_min_spend_free_gift ) {
            cartUpdates = {  ...cartUpdates, [second_free_gift_without_threshold_variant_id]: 0 }
          }
      } else if ( ( cartItems.length >= 1 ) && ( qtyInTheCart !== 1 ) ) {
        cartUpdates = {  [variant_id] : 1 }
          
        // 2nd freebie
        if ( enable_second_no_min_spend_free_gift ) {
          cartUpdates = {  ...cartUpdates, [second_free_gift_without_threshold_variant_id]: 1 }
        }
      }

      if (free_gift_over_100_product_tag) {
        const tagTotalPrice = totalPriceForProductTag(cart, free_gift_over_100_product_tag);
        if (enable_free_gift_over_100_spend && tagTotalPrice >= 10000) {
          if (Object.keys(cartUpdates).length) {
            cartUpdates = {  ...cartUpdates, [free_gift_over_100_spend_variant_id]: 1 }
          } else {
            cartUpdates = {  [free_gift_over_100_spend_variant_id]: 1 }
          }
        } else if( tagTotalPrice < 10000 && hasOver100Freebie) {
          if (Object.keys(cartUpdates).length) {
            cartUpdates = {  ...cartUpdates, [free_gift_over_100_spend_variant_id]: 0 }
          } else {
            cartUpdates = {  [free_gift_over_100_spend_variant_id]: 0 }
          }
        }
      } else {
        if (enable_free_gift_over_100_spend && cart.items_subtotal_price >= 10000) {
          if (Object.keys(cartUpdates).length) {
            cartUpdates = {  ...cartUpdates, [free_gift_over_100_spend_variant_id]: 1 }
          } else {
            cartUpdates = {  [free_gift_over_100_spend_variant_id]: 1 }
          }
        } else if( cart.items_subtotal_price < 10000 && hasOver100Freebie) {
          if (Object.keys(cartUpdates).length) {
            cartUpdates = {  ...cartUpdates, [free_gift_over_100_spend_variant_id]: 0 }
          } else {
            cartUpdates = {  [free_gift_over_100_spend_variant_id]: 0 }
          }
        }
      }
      if ( !( cartItems.length === 1 ) && ( qtyInTheCart > 0 )  &&
      !removeFreebie &&
      !(( cartItems.length >= 1 ) && ( qtyInTheCart !== 1 ) && !hasFreebie) && 
      !(cart.items_subtotal_price < 10000 && hasOver100Freebie) && 
      !(enable_free_gift_over_100_spend && cart.items_subtotal_price >= 10000) ) {
        console.log('returned');
        return;
      }
      
      const params = {
        type: 'POST',
        url: '/cart/update.js',
        data: { updates: cartUpdates },
        dataType: 'json',
        success: function() { 
          Shopify.theme.jsAjaxCart.updateView();
        }
      };
      $.ajax(params);

   } else if (enable_buy_1_get_1 == true) {
      for (var i=0; i<cartItems.length; i++) {
        if ( cartItems[i].id === buy_1_get_1_variant ) {
          qtyInTheCart = cartItems[i].quantity;
          break;
        }
      }
      console.log(qtyInTheCart)
      if ( qtyInTheCart > 0 ) {
        cartUpdates = { [freebie_buy_1_get_1_variant]: qtyInTheCart }
      } else {
        cartUpdates = { [freebie_buy_1_get_1_variant]: 0 }
      }
      console.log(cartUpdates)
      $.post('/cart/update.js', {
        updates: cartUpdates,
        success: function success() {
          window.setTimeout(function () {
            Shopify.theme.jsAjaxCart.updateView();
          }, 1000);
        }
      });
    } else {
      Shopify.theme.jsAjaxCart.updateView();
    }
  });
}


Shopify.theme.jsAjaxCart = {
  init: function init($section) {

    // Add settings from schema to current object
    Shopify.theme.jsAjaxCart = $.extend(this, Shopify.theme.getSectionData($section));

    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }
    
    $(document).on('click', function(e){
      Shopify.theme.jsAjaxCart.hideMiniCartIfClickOutside(e)
    })

    if (this.cart_action == 'drawer') {
      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');
      $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
        e.preventDefault();
        Shopify.theme.jsAjaxCart.showDrawer();
        return false;
      });
    } else if (this.cart_action == 'mini_cart') {
      this.showMiniCartOnHover();
    }

    /* --------------- init the close button for mini cart mobile --------------- */
    
    $(document).on('click', '.ajax-cart__title .btn_close', function(){
      $('.header-cart').trigger('click')
    });

    /* -------------------------------------------------------------------------- */


    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      var $addToCartForm = $(this).closest('form');
      Shopify.theme.jsAjaxCart.addToCart($addToCartForm);
      return false;
    });
    $(document).on('click', '[data-ajax-cart-delete]', function (e) {
      e.preventDefault();
      var lineID = $(this).parents('[data-line-item]').data('line-item');
      Shopify.theme.jsAjaxCart.removeFromCart(lineID);

      if (Shopify.theme.jsCart) {
        Shopify.theme.jsCart.removeFromCart(lineID);
      }

      return false;
    });
    $(document).on('click', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      Shopify.theme.jsAjaxCart.hideDrawer();
      Shopify.theme.jsAjaxCart.hideMiniCart();
      return false;
    });
    Shopify.theme.jsAjaxCart.hideWishlistDefaultPopup();
  },

  showMiniCartOnHover: function showMiniCartOnHover() {
    var $el = $('[data-ajax-cart-trigger]');
    let showMiniCartFunc = function (e) {
      const threshold = 693;
      const $ajaxCart = $('#theme-ajax-cart');
      const offset = threshold - window.innerWidth/2;
      

      // mini cart position adjust logic
      if(window.innerWidth > 1608) {
        $ajaxCart.css('right', '-110px');
      } else {
        if(offset < 0) {
          $ajaxCart.css('right', offset);
        } else {
          $ajaxCart.css('right', 0);
        }
      }
      if (Shopify.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
        $('.header-sticky-wrapper [data-ajax-cart-trigger]').toggleClass('show-mini-cart');
      } else {
        $el.toggleClass('show-mini-cart');
      }
      Shopify.theme.jsAjaxCart.miniCartTimeOutHandle()

      // // clear all time out before set
      // let id = window.setTimeout(function() {}, 0);

      // while(id--) {
      //   window.clearTimeout(id);
      // };

      // // close mini cart when time out
      // const timeout = setTimeout(() => {
      //   $el.removeClass('show-mini-cart');
      //   $('html').removeClass('show-mini-cart');
      // }, 5000);
    };

    $('#miniIcon').on('click', e => {
      if ($(window).width()>768){
        window.location.pathname = '/cart';
        return
      }
      showMiniCartFunc();
    }).on('mouseenter',e=>{
      // showMiniCartFunc();
      var $el = $('[data-ajax-cart-trigger]');
      $el.addClass('show-mini-cart').on('mouseout',function(){
        // console.log('mouseout')
        Shopify.theme.jsAjaxCart.miniCartTimeOutHandle('')
      });
    });
  },

  miniCartMouseEnter(){
    let $minicart= $('.ajax-cart__list')
    const self=this
    if($(window).width()>768){
      $minicart.on('mouseenter',function(){
        // console.log('mouseenter')
        self.miniCartTimeOutHandle('mouseenter')
      }).on('mouseout',function(){
        // console.log('mouseout')
        self.miniCartTimeOutHandle('')
      })
    }else{
      // mobile behave different with desktop
      $minicart.on('scroll',function(){
        // console.log('scroll')
        self.miniCartTimeOutHandle('')
      }).on('click',function(){
        // console.log('click')
        self.miniCartTimeOutHandle('')
      })
    }
  },

  miniCartTimeOutHandle(mouse=""){
    var $el = $('[data-ajax-cart-trigger]');
    // clear all time out before set
    let id = window.setTimeout(function() {}, 0);
    while(id--) {
      window.clearTimeout(id);
    };

    // close mini cart when time out
    if (mouse === "") {
      const timeout = setTimeout(() => {
          // console.log('testing')
          $el.removeClass('show-mini-cart');
          $('html').removeClass('show-mini-cart');
        }, 5000);
    }
  },

  hideMiniCartIfClickOutside(e) {
    const $target = $(e.target);
    const $minicart = $('#theme-ajax-cart');
    const $cartIcon = $('.header_cart_container');
    if($target.closest('.header_cart_container').length != 0 ) return;

    if($target.closest('#theme-ajax-cart').length != 0) return;

    $cartIcon.removeClass('show-mini-cart');
    $('html').removeClass('show-mini-cart');
  },
  hideMiniCart: function hideMiniCart() {
    if (this.cart_action != 'mini_cart') return false;
    var $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
    $el.removeClass('show-mini-cart');
  },
  toggleMiniCart: function toggleMiniCart() {
    var $el = $('.mobile-header [data-ajax-cart-trigger]'); // Removes url to the cart page so user is not redirected
    var $nav = $('.mobile-header .mobile-menu__toggle-icon');
    var $body = $('body.swym-ready');
    var $icon = $('.mobile-header .mobile-menu__toggle-button');
    $el.attr('href', '#');
    $el.off('click').on('click', function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest('[data-ajax-cart-mini_cart]')) {
        return;
      } // Loads content into ajaxCart container for mobile header

      Shopify.theme.jsAjaxCart.initializeAjaxCartOnMobile(); // If user clicks outside the element, toggle the mini cart

      if(!$el.hasClass('show-mini-cart') && $nav.hasClass('is-active')) {
        $nav.removeClass('is-active');
        $body.removeClass('mobile-menu--opened');
        $icon.attr('data-show-mobile-menu', false)
      }


      $el.toggleClass('show-mini-cart'); // Calculate height of mini cart

      if($el.hasClass('show-mini-cart')) {
        $('html').addClass('show-mini-cart');
      } else {
        $('html').removeClass('show-mini-cart');
      }

      var announcementHeight = 0;
      var mobileHeaderHeight = parseInt($('.mobile-header').height());

      if (typeof Shopify.theme.jsAnnouncementBar !== 'undefined' && Shopify.theme.jsAnnouncementBar.enable_sticky) {
        announcementHeight = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();
      }

    });
  },
  showDrawer: function showDrawer() {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.addClass('is-visible');
    $('.ajax-cart__overlay').addClass('is-visible');
    $('body').addClass('drawer-open');
  },
  hideDrawer: function hideDrawer() {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');
    $('body').removeClass('drawer-open');
  },
  removeFromCart: function removeFromCart(lineID, callback) {
    Shopify.theme.quantityBox.updateCart(lineID, 0);
    /*
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function success(cart) {
        checkForFreebie();
        // Shopify.theme.jsAjaxCart.updateView();
      },
      error: function error(XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
    */
  },
  initializeAjaxCart: function initializeAjaxCart() {
    Shopify.theme.asyncView.load('/cart', // template name
    'ajax' // view name (suffix)
    ).done(function (_ref) {
      var html = _ref.html,
          options = _ref.options;
      var items = $(html.content).filter('#cart-info').html();
      Shopify.theme.localHelper.delete('cart_items', items);
      Shopify.theme.localHelper.save('cart_items', items);
      $('[data-ajax-cart-content]').html(html.content);
      // load miniCartMouseEnter after html loaded
      Shopify.theme.jsAjaxCart.miniCartMouseEnter()
    //   if (Shopify.theme_settings.show_multiple_currencies) {
    //     convertCurrencies();
    //   }
      //($('.ajax-cart__quntity .input-number'));
    }).fail(function () {// some error handling
    });
  },
  initializeAjaxCartOnMobile: function initializeAjaxCartOnMobile() {
    // console.log('toggle')
    this.toggleMiniCart();
    Shopify.theme.asyncView.load('/cart', // template name
    'ajax' // view name (suffix)
    ).done(function (_ref2) {
      var html = _ref2.html,
          options = _ref2.options;
      $('.mobile-header [data-ajax-cart-content]').html(html.content);
      // load after html loaded
      Shopify.theme.jsAjaxCart.miniCartMouseEnter()
    //   if (Shopify.theme_settings.show_multiple_currencies) {
    //     convertCurrencies();
    //   }
      //inputNumber($('.ajax-cart__quntity .input-number'));
    }).fail(function () {// some error handling
    });
  },
  addToCart: function addToCart($addToCartForm) {
    var $addToCartBtn = $addToCartForm.find('.button--add-to-cart');
    var $newAddToCartBtn = $('.purchase-addtocartbtn__container .button--add-to-cart');
    var tier = +$addToCartBtn.data('tier');
    var id = +$addToCartBtn.data('id');
    var str = $addToCartForm.serialize();
    var myRegexp = /quantity=(.*)/g;
    var match = myRegexp.exec(str);
    var quantity = match != null ? +match[1] : 1;
    var is_over_max = false;
    var cart_quantity = 0;
    var MAX_QUANTITY = +$addToCartBtn.data('max-quantity');

    if(tier > 1) {
      var cart_items = Shopify.theme.localHelper.get('cart_items');
      Shopify.theme.localHelper.get('cart_items');
      if(cart_items.length > 0) {
        is_over_max = cart_items.filter(item => {
          if(item.id === id && item.quantity + quantity > MAX_QUANTITY) {
            cart_quantity = item.quantity;
            return item;
          }
        }).length > 0;
      }
      if(quantity > MAX_QUANTITY) {
        is_over_max = true;
      }
    }

    if(is_over_max) {
      Swal.fire({
        title: 'Oops!',
        text: `You don\'t have enough Token for purchasing. Token Left: ${MAX_QUANTITY - cart_quantity}`,
        icon: 'error',
        confirmButtonText: 'Cool'
      })
      return;
    }
    // return if the add to cart button has onclick attribute
    if ($addToCartBtn.attr('onclick')) {
      return false;
    }

    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $addToCartForm.serialize(),
      beforeSend: function beforeSend() {
        $addToCartBtn.find('span').hide();
        $addToCartBtn.find('.checkmark').show();
        $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
        
        if ($newAddToCartBtn.length) {
          // $newAddToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          // $newAddToCartBtn.find('.text').removeClass("fadeInDown").addClass('animated zoomOut');
          // $newAddToCartBtn.find('.added-to-cart-status').addClass('show-added-status');
          $newAddToCartBtn.find('.text').hide();
          $newAddToCartBtn.find('.added-to-cart-status').show();
          $newAddToCartBtn.attr('disabled', 'disabled').addClass('disabled');
        }
      },
      success: function success(product) {
        var $el = $('[data-ajax-cart-trigger]');
        $addToCartBtn.find('span').show();
        $addToCartBtn.find('.checkmark').hide();
        $addToCartBtn.removeAttr('disabled').removeClass('disabled');

        $newAddToCartBtn.find('.text').show();
        $newAddToCartBtn.find('.added-to-cart-status').hide();
        $newAddToCartBtn.removeAttr('disabled').removeClass('disabled');
        // if ($newAddToCartBtn.length) {
        //   $newAddToCartBtn.find('.checkmark').addClass('checkmark-active');
        // }
        
        function addedToCart() {
          if (!isScreenSizeLarge()) {
            $el = $('.mobile-header [data-ajax-cart-trigger]');
            // Shopify.theme.scrollToTop($el);
          } else {
            $el = $('[data-ajax-cart-trigger]');
          }

          $el.addClass('show-mini-cart');

          // clear all time out before set
          let id = window.setTimeout(function() {}, 0);

          while(id--) {
            window.clearTimeout(id);
          };

          // close mini cart when time out
          setTimeout(() => {
            $el.removeClass('show-mini-cart');
            $('html').removeClass('show-mini-cart');
          }, 5000);
          $('html').addClass('show-mini-cart');
          $addToCartBtn.find('span').removeClass('fadeInDown');
        }

        // window.setTimeout(function () {
        //   $addToCartBtn.removeAttr('disabled').removeClass('disabled');
        //   $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
        //   $addToCartBtn.find('.text, .icon').removeClass('zoomOut').addClass('fadeInDown');
        //   $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);
        //   if ($newAddToCartBtn.length) {
        //     $newAddToCartBtn.removeAttr('disabled').removeClass('disabled');
        //     $newAddToCartBtn.find('.checkmark').removeClass('checkmark-active');
        //     $newAddToCartBtn.find('.text, .icon').removeClass('zoomOut').addClass('fadeInDown');
        //     $newAddToCartBtn.find('.added-to-cart-status').removeClass('show-added-status');
        //     $newAddToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);
        //   }
        // }, 1000);
        
        addedToCart()
        Shopify.theme.jsAjaxCart.showDrawer();
        Shopify.theme.jsAjaxCart.updateView();
        setTimeout(() => {
          checkForFreebie();
        }, 300);

        if (Shopify.theme.jsCart) {
          var _$$ajax;

          $.ajax((_$$ajax = {
            dataType: "json",
            async: false,
            cache: false
          }, _defineProperty(_$$ajax, "dataType", 'html'), _defineProperty(_$$ajax, "url", "/cart"), _defineProperty(_$$ajax, "success", function success(html) {
            var cartForm = $(html).find('.cart__form');
            $('.cart__form').replaceWith(cartForm);

            // if (Shopify.theme_settings.show_multiple_currencies) {
            //   convertCurrencies();
            // }
          }), _$$ajax));
        }
      },
      error: function error(XMLHttpRequest) {
        $addToCartBtn.find('span').show();
        $addToCartBtn.find('.checkmark').hide();
        $addToCartBtn.removeAttr('disabled').removeClass('disabled');

        $newAddToCartBtn.find('.text').show();
        $newAddToCartBtn.find('.added-to-cart-status').hide();
        $newAddToCartBtn.removeAttr('disabled').removeClass('disabled');
        
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
        var cartWarning = "<p class=\"cart-warning__message animated bounceIn\">".concat(response.replace('All 1 ', 'All '), "</p>");
        $('.warning').remove();
        $addToCartForm.find('.cart-warning').html(cartWarning);
        $addToCartBtn.removeAttr('disabled').removeClass('disabled');
        $addToCartBtn.find('.icon').removeClass('zoomOut').addClass('zoomIn');
        $addToCartBtn.find('.text').text(Shopify.translation.addToCart).removeClass('zoomOut').addClass('zoomIn');
        if ($newAddToCartBtn.length) {
          $newAddToCartBtn.removeAttr('disabled').removeClass('disabled');
          $newAddToCartBtn.find('.icon').removeClass('zoomOut').addClass('zoomIn');
          $newAddToCartBtn.find('.text').text(Shopify.translation.addToCart).removeClass('zoomOut').addClass('zoomIn');
        }
      }
    });
  },
  updateView: function updateView() {
    Shopify.theme.asyncView.load('/cart', // template name
    'ajax' // view name (suffix)
    ).done(function (_ref3) {
      var html = _ref3.html,
          options = _ref3.options;
      var items = $(html.content).filter('#cart-info').html();
      Shopify.theme.localHelper.delete('cart_items', items);
      Shopify.theme.localHelper.save('cart_items', items);
      if (options.item_count > 0) {
        var itemList = $(html.content).find('.ajax-cart__list');
        var cartDetails = $(html.content).find('.ajax-cart__details-wrapper');
        $('.ajax-cart__list').replaceWith(itemList);
        $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
        $('.ajax-cart__empty-cart-message').addClass('hidden');
        $('.ajax-cart__form').removeClass('hidden');
        $('[data-ajax-cart-trigger]').addClass('has-cart-count');
        $('[data-bind="itemCount"]').text(options.item_count);
      } else {
        $('.ajax-cart__empty-cart-message').removeClass('hidden');
        $('.ajax-cart__form').addClass('hidden');
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
      }

      // checkForFreebie();

    //   if (Shopify.theme_settings.show_multiple_currencies) {
    //     convertCurrencies();
    //   }
      // load miniCartMouseEnter while refresh the minicart
      Shopify.theme.jsAjaxCart.miniCartMouseEnter()

      //inputNumber($('.ajax-cart__quntity .input-number'));
    }).fail(function () {// some error handling
    });
  },
  unload: function unload($section) {
    // Clear event listeners in theme editor
    $('.ajax-submit').off();
    $('[data-ajax-cart-delete]').off();
  },
  // no specific js file for wishlist page
  // this func will hide default wishlist popup window after click the btn
  hideWishlistDefaultPopup: function hideWishlistDefaultPopup() {
    $('body').on('click', '.swym-tab-overlay .swym-button.swym-background-color', e => {
      let all_parentEles = $('.swym-tab-overlay');
      all_parentEles.map((i, e) => {
        e.classList.add('swym-tab-overlay-hide')
      })
    })
  }
};